export default { sha: 'cf52787783f937956f46f7358dbe545c0371199a', buildNumber: 'undefined' }
